import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency } from 'src/app/services/constants';

@Pipe({
  name: 'currencyFormat',
})
export class CurrencyFormatPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    return formatCurrency(value);
  }
}
